export const SOCIAL_SHARE_TYPES = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  EMAIL: 'email'
};
